/**
 * @generated SignedSource<<6122a26ea5ff5aea1ec38729899daaf9>>
 * @relayHash 8b42fe82152ee6b0b66e10d8e9264f48
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b42fe82152ee6b0b66e10d8e9264f48

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HtmlTag = "HTML";
export type ChangeAllThatApplyDetailsInput = {
  answer?: ReadonlyArray<boolean> | null;
  bodyItemId: string;
  clientMutationId?: string | null;
  options?: ReadonlyArray<HtmlInput> | null;
  prompt?: HtmlInput | null;
  updateAnswer?: boolean | null;
  updateOptions?: boolean | null;
  updatePrompt?: boolean | null;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type AllThatApplyChangeMutation$variables = {
  input: ChangeAllThatApplyDetailsInput;
};
export type AllThatApplyChangeMutation$data = {
  readonly changeAllThatApplyDetails: {
    readonly bodyItem: {
      readonly answer: any | null;
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type AllThatApplyChangeMutation = {
  response: AllThatApplyChangeMutation$data;
  variables: AllThatApplyChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeAllThatApplyDetailsPayload",
    "kind": "LinkedField",
    "name": "changeAllThatApplyDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllThatApplyChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllThatApplyChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8b42fe82152ee6b0b66e10d8e9264f48",
    "metadata": {},
    "name": "AllThatApplyChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "979bb37310bf2f30a518a032649b7c59";

export default node;
